export var CalculationResultType;
(function (CalculationResultType) {
    CalculationResultType["RValue"] = "RValue";
    CalculationResultType["UValue"] = "UValue";
})(CalculationResultType || (CalculationResultType = {}));
